var map = {
	"./camera.svg": 325,
	"./delete.svg": 326,
	"./done.svg": 327,
	"./error.svg": 328,
	"./imgDelete.svg": 329,
	"./left.svg": 330,
	"./message.svg": 331,
	"./player.svg": 332,
	"./refresh.svg": 333,
	"./right.svg": 334,
	"./undone.svg": 335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 324;